<template>
<m-pageframe
    title="Search Contact Requests: {organization-label}"
    :color="pageframe_color"

>
<v-container
    fluid
    style="padding-left: 30px; padding-right: 30px;"
    v-if="profile != null"
>

    <v-text-field
        v-model="full_text"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        style="margin-bottom: 15px;"
        v-on:input="update"
        autocomplete="off"
     >
        <span slot="append-outer">
               <v-menu 
                   bottom 
                   offset-y  
               >
               
               <template v-slot:activator="{ on }">
                       
                   <v-icon 
                       v-on="on"
                   >
                       mdi-dots-vertical
                   </v-icon>
                       
               </template>
               
               <v-list>
                   <v-list-item
                       v-on:click="onClickReset()"
                   >
                       <v-list-item-title>Reset Search...</v-list-item-title>
                   </v-list-item>

                   <v-divider/>

                   <v-list-item
                       v-on:click="onClickExport()"
                   >
                       <v-list-item-title>Export to Excel...</v-list-item-title>
                   </v-list-item>

                   
               
               </v-list>
               
               </v-menu>  
        </span>
    </v-text-field>

     <v-select
        label="Source"
        :items="$rc.enumChoices('contact_request_source', true, 'Any Source')"
        v-model="source"
        v-on:change="doUpdate"
     />

     <v-select
        label="Inbox"
        :items="profile.inbox_choices"
        v-model="inbox_id"
        v-on:change="doUpdate"
    />

     <v-select
        label="Team Member"
        :items="profile.employee_choices"
        v-model="owned_by_employee_id"
        v-on:change="doUpdate"
    />

    <v-select
        label="Response"
        :items="profile.response_choices"
        v-model="response"
        multiple
        chips
        v-on:change="doUpdate"
    />

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="clickable-rows elevation-1"
        :hide-default-footer="true"
        disable-sort

        v-on:click:row="onClickViewDetails"
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.creation_date="{ item }">
            {{$rc.pretty(item.creation_time,'date')}}
        </template>

        <template v-slot:item.creation_time="{ item }">
            {{$rc.pretty(item.creation_time,'time')}}
        </template>

        <template v-slot:item.source="{ item }">
            {{pretty(item.source,'source')}}
        </template>

         <template v-slot:item.source_detail="{ item }">
            {{pretty(item.source_detail,'source_detail')}}
        </template>

        <template v-slot:item.customer_endpoint="{ item }">
            {{$rc.pretty(item.customer_endpoint)}}
        </template>

        <template v-slot:item.response="{ item }">
            {{pretty(item.response,'response')}}
        </template>

        <template v-slot:item.response_delay_ms="{ item }">
            {{pretty(item.response_delay_ms,'response_delay_ms')}}
        </template>

        <template v-slot:item.has_payment="{ item }">
            
            <v-simple-checkbox
                :value="item.payment_id != null"
                v-ripple="false"
                disabled
            />
              
        </template>

        
    
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickViewConversation(item)"
                >
                    <v-list-item-title>View Conversation...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickViewDetails(item)"
                >
                    <v-list-item-title>View Details...</v-list-item-title>
                </v-list-item>

                <v-divider
                    v-if="item.customer_endpoint_in_crms.length > 0"
                />

                <v-list-item
                    v-for="(crm, index) in item.customer_endpoint_in_crms"
                    :key="index"
                    v-on:click="onClickOpenInCRM(item, crm)"
                >
                    <v-list-item-title>View in {{$rc.pretty(crm,'integration_name')}}...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>

    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const Time = require('@/js/time.js');
const E164 = require('@/js/E164.js');
const _ = require('lodash');

export default 
{
    data() {
        return {
            profile: null,
            
            full_text: null,
            source: 'any_enum_value',
            owned_by_employee_id: '*', 
            inbox_id: '*',
            response: ['open','responded','forwarded','no-response-required'],

            
            results: [],

            headers: [
                { text: 'Date', value: 'creation_date' },
                { text: 'Time', value: 'creation_time' },
                { text: 'Source', value: 'source'},
                { text: 'Source Detail', value: 'source_detail' },
                { text: 'Inbox', value: 'inbox_internal_label' },
                { text: 'Customer Name', value: 'customer_name' },
                { text: 'Customer Phone', value: 'customer_endpoint' },
                { text: 'Response', value: 'response' },
                { text: 'Response Detail', value: 'response_detail' },
                { text: 'Response Time (min)', value: 'response_delay_ms' },
                { text: 'Payment', value: 'has_payment' },
                { text: 'Action', value: 'action' }
            ],
        }
    },

    mounted () {
        this.inbox_id = this.$route.params.inbox_id == null ? '*' : this.$route.params.inbox_id;

        this.updateOrganizationProfile();
        this.doUpdate();
    },

    methods: {
        updateOrganizationProfile() {
            
            this.$rc.rest(
                'GET: /api/v1/search-contact-requests/organization-profile/:organization_id',
        
                {
                    'organization_id' : this.$route.params.organization_id,
                },
            
                (data) => {
                    this.profile = data;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );

        },


        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            let source = this.source;
            if ( source == 'any_enum_value' ) source = null;

            let search = {
                    'organization_id': this.$route.params.organization_id,
                    'full_text': this.full_text,
                    'source': source,
                    'owned_by_employee_id': this.owned_by_employee_id, 
                    'inbox_id': this.inbox_id,
                    'response': this.response,
                };
            
            this.$rc.rest(
                'LIST: /api/v1/search-contact-requests',
            
                search,
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },


        onClickReset()
        {
            this.full_text = null;
            this.source = '*';
            this.owned_by_employee_id = '*'; 
            this.inbox_id = '*';
            this.response = ['open','responded','forwarded'];

            this.update();
        },

        pretty(value, type)
        {
            if ( type == 'source' )
            {
                return this.$rc.pretty(value, 'enum_contact_request_source');
            }

            if ( type == 'source_detail' )
            {
                if ( value != null && value.startsWith('InboxEmailParser') ) 
                    return value.substring('InboxEmailParser'.length);
            }

            if ( type == 'response' )
            {
                if ( value == 'open' ) return 'Open';
                if ( value == 'marked-as-spam' ) return 'Spam';
                if ( value == 'responded' ) return 'Responded';
                if ( value == 'forwarded' ) return 'Forwarded';  
                if ( value == 'no-response-required' ) return 'N/A'; 
            }

            if ( type == 'response_delay_ms' )
            {
                if ( value == null ) return null;

                let ret = value;
                ret /= 60;
                ret /= 1000;

                return Math.round(ret);
            }

            return value;
        },

        onClickViewConversation(item)
        {
            let contact_request_id = item.contact_request_id;

            this.$rc.showSpinner();
            
            this.$rc.getContactRequestConversationLink(
                contact_request_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    let conversation_link = data.conversation_link;

                    if ( conversation_link == null )
                    {
                        this.$rc.alert('Error','Unable to find conversation');
                        return;
                    }

                    this.$router.push({
                                'name': 'home-routed',
                                'params' : conversation_link,
                            })
                        .catch(e=>{});
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to find conversation');
                },
            );
        },

        onClickViewDetails(item)
        {
          this.$router.push({
            'name': 'contact-request-detail',
            'params' : {
              'contact_request_id' : item.contact_request_id
            }
          });
        },

        onClickExport()
        {
            let source = this.source;
            if ( source == 'any_enum_value' ) source = null;

            this.$rc.excelExport(
                    'EXPORT: /api/v1/search-contact-requests/:in_organization_id',
                    {
                        'in_organization_id' : this.$route.params.organization_id,
                        'organization_id' : this.$route.params.organization_id,

                        'full_text': this.full_text,
                        'source': source,
                        'owned_by_employee_id': this.owned_by_employee_id, 
                        'inbox_id': this.inbox_id,
                        'response': this.response,
                    }
                );
        },

        onClickRow(row)
        {
          this.viewDetails(row.contact_request_id);
        },

        onClickOpenInCRM(row, crm_name)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/integrations/crm/customers/from-endpoint',
            
                {
                    'content_type' : crm_name,
                    'organization_id' : row.organization_id,
                    'endpoint' : row.customer_endpoint
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    let results = data.results;
                    if ( results.length == 0 )
                    {
                        this.$rc.alert('Error','No customer for this contact exists in '+crm_name);
                        return;
                    }

                    window.open(results[0].url_view_customer_in_crm);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to search '+crm_name+' customers');
                },
            );
        },
    },

    computed: {
        pageframe_color() {
            if ( this.$route.params.organization_id !== this.$rc.$state.organization_id )
                return '#5D647C';
            else
                return '#F24653';
        },
    },
}
</script>

<style lang="scss" scoped>
</style>